import React from 'react';
import ButtonIcon from './ButtonIcon';

const IconPlus: React.FC<any> = () => {
    return (

        <ButtonIcon
            color={'lightgray'}
            size={'1.4rem'}
            icon={'fa-plus'}
            mask={'fa-square'}
            shrink={7}
        />
    );
};
export default IconPlus;